export const getNetworkName = (name: string) => {
  switch (name) {
    case 'arbitrum':
      return 'Arbitrum'
    case 'bsc':
      return 'BNB Chain'
    case 'mainnet':
      return 'Ethereum'
    case 'worldchain':
      return 'World Chain'
    case 'mega-eth':
      return 'MegaETH'
    case 'robinhood':
      return 'Robinhood Chain'
    default:
      return name
  }
}
